import { RccCodes } from 'gl-commonui';

/**
 * Maps each extra-tenant RCC code to its gateway API prefix env var.
 * When the current site is NOT one of these tenants, data is fetched
 * from each configured gateway and merged into the primary results.
 *
 * To add a new region:
 *   1. Add its env var to webpack configs (e.g. apiPrefixChina)
 *   2. Add one entry here: [RccCodes.China]: (process.env as any).apiPrefixChina
 */
export const EXTRA_GATEWAY_MAP: Partial<Record<string, string>> = {
    [RccCodes.Russia]: (process.env as any).apiPrefixRussia,
    // [RccCodes.China]: (process.env as any).apiPrefixChina,
};
